import { createApi } from '@kdk/shared';
import { getToken } from '../auth/session';
import { notifyUnauthorized } from '../auth/unauthorized';
import { env } from '../config/env';

export const api = createApi({
  baseUrl: env.apiBaseUrl,
  getToken,
  onUnauthorized: notifyUnauthorized,
});
